import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { UPLOAD_SOURCES } from '@cld/upload-widget-common';
import TabHeader from 'root/components/TabHeader';
import t from 'common/i18n';
import useCurrentPage from '../../hooks/useCurrentPage';
import { useSearchParams, useSelectedAsset, useAssets, useHomePageAssets } from '../../selectors';
import { getInternalPath } from '../../utils';
import { ROUTES } from '../../data/consts';
import { TabHeaderButtons } from '../../../common/components/TabHeaderButtons';

const { UNSPLASH } = UPLOAD_SOURCES;

const Root = styled.div`
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
`;

export default ({ handleLogout, handleSearch, handleClearSearchTerm, handleTogglePanel, isFiltersPanelOpen, areFiltersSet }) => {
  const history = useHistory();
  const [searchPhraseLocal, setSearchPhraseLocal] = useState('');
  const { searchPhrase } = useSearchParams();
  const { isSummaryPage } = useCurrentPage();
  const { selectedAsset } = useSelectedAsset();
  const { items: homeItems } = useHomePageAssets();
  const { items } = useAssets();

  useEffect(() => {
    setSearchPhraseLocal(searchPhrase);
  }, [searchPhrase]);

  const clearSearchTerm = useCallback(() => {
    handleClearSearchTerm({ searchPhrase: searchPhraseLocal });
  }, [handleClearSearchTerm, searchPhraseLocal]);

  const onSearch = useCallback(() => {
    handleSearch({ searchPhrase: searchPhraseLocal });
  }, [handleSearch, searchPhraseLocal]);

  const handlePurchaseBack = useCallback(() => {
    if (items.length) {
      history.push(getInternalPath(ROUTES.SEARCH));
    } else {
      history.push(getInternalPath(ROUTES.HOME));
    }
  }, [history, items]);
  return (
    <Root disabled={!homeItems.length}>
      <TabHeader
        source={UPLOAD_SOURCES.ISTOCK}
        searchTerm={searchPhraseLocal}
        expandSearch
        hideBackButton
        onLogout={handleLogout}
        searchClickHandler={onSearch}
        searchTermHandler={setSearchPhraseLocal}
        clearBtnTip={t('search.reset')}
        showClearButton={!!searchPhraseLocal}
        onClearClickHandler={clearSearchTerm}
        onEscClickHandler={clearSearchTerm}
        titleCenter={isSummaryPage && selectedAsset.title}
        searchInputPlaceholder={t('search.placeholder')}
        showBackButton={isSummaryPage}
        showSearch={!isSummaryPage}
        onBackNavigation={handlePurchaseBack}
      >
        {!isSummaryPage && (
          <TabHeaderButtons
            id={UNSPLASH}
            routes={ROUTES}
            searchTerm={searchPhraseLocal}
            clearSearchTerm={() => clearSearchTerm()}
            isFiltersPanelOpen={isFiltersPanelOpen}
            showIndicator={areFiltersSet && !isFiltersPanelOpen}
            toggleFilterPanel={handleTogglePanel}
            filterBtnDataTest={isFiltersPanelOpen ? 'opened-filters' : 'closed-filters'}
          />
        )}
      </TabHeader>
    </Root>
  );
};
